import React from "react";
import { QuotaInput } from "./QuotaInput";

export const QuotaForm = ({
  quotas,
  quotasErrors,
  onInputChange,
  onSave,
  isSubmitting,
  t,
}) => {
  
  return (
    <>
      <div className="form-group row">
        <QuotaInput
          id="unite"
          label="Quota pour affectation vers une unité"
          type="number"
          min={0}
          max={100}
          value={quotas.unite}
          onChange={(e) => onInputChange("unite", e.target.value)}
          errors={quotasErrors.unite}
          t={t}
        />
        <QuotaInput
          id="staff"
          label="Quota pour affectation vers un staff"
          value={quotas.staff}
          onChange={(e) => onInputChange("staff", e.target.value)}
          errors={quotasErrors.staff}
          t={t}
        />
      </div>

      <div className="form-group row">
        <QuotaInput
          id="traitement"
          label="Quota pour affectation traitement"
          value={quotas.traitement}
          onChange={(e) => onInputChange("traitement", e.target.value)}
          errors={quotasErrors.traitement}
          t={t}
        />
        <QuotaInput
          id="validation"
          label="Quota pour affectation validation"
          value={quotas.validation}
          onChange={(e) => onInputChange("validation", e.target.value)}
          errors={quotasErrors.validation}
          t={t}
        />
      </div>

      <div className="form-group row">
        <div className="col-md-6 col-xs-12">
          <QuotaInput
            id="satisfaction"
            label="Quota pour affectation mesure de satisfaction"
            value={quotas.satisfaction}
            onChange={(e) => onInputChange("satisfaction", e.target.value)}
            errors={quotasErrors.satisfaction}
            t={t}
          />
        </div>
      </div>

      <div className="kt-portlet__foot">
        <div className="kt-form__actions text-right">
          <button
            type="submit"
            onClick={onSave}
            className="btn btn-primary"
            disabled={isSubmitting}
          >
            {isSubmitting ? t("Chargement") + "..." : t("Enregistrer")}
          </button>
        </div>
      </div>
    </>
  );
};
